export default "__VITE_ASSET__FN_HV51x__"